import {RemotePatchFavoritePlace} from 'data/usecases';
import {PatchFavoritePlace} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makePatchFavoritePlace = (cdBeneficiarioEnderecoFavorito: number): PatchFavoritePlace =>
  new RemotePatchFavoritePlace(
    makeBFFApiUrl(`${GuideFlowEndpoints.medicalFavoritePlace}/${cdBeneficiarioEnderecoFavorito}`),
    makeAuthorizeHttpClientDecorator(),
  );
